"use client";
import { FC, useState } from "react";
import CasinoSearchModal from "../CasinoPage/CasinoSearchModal";
import SVGIcon from "../SVGIcon";
import { useTranslations } from "next-intl";
import { I18N_NAMESPACE } from "@/config/i18n";
import useEffect from "react";
import useTracking from "../Hooks/useTracking";

const Search: FC<{
  isLive?: boolean;
}> = ({ isLive }) => {
  const { track } = useTracking();
  const [showSearchModal, setShowSearchModal] = useState<boolean>(false);
  const t = useTranslations(I18N_NAMESPACE.SEARCH);
  return (
      <div className="md:min-w-[240px]">
        <div className="px-0.5 border-primary/30  py-0.5 border rounded-3xl flex items-center gap-3">
          <input
            className={`w-full p-0 pl-4 text-sm lg:block hidden font-normal bg-transparent border-none leading-5.5 text-tertiary/50 focus:border-primary-500 focus:shadow-none focus:ring-0 dark:placeholder:text-tertiary-50/50 dark:text-white autofill:!bg-transparent`}
            type="text"
            id="game-name"
            placeholder={t("gamename-provider")}
            onClick={() => {
              setShowSearchModal(true);
              track(`open search modal`, {
                selectedPage: isLive ? "Live Casino Page" : "Casino Page",
                component: "searchModal - Search",
              });
            }}
          />
          <button
            onClick={() => {
              setShowSearchModal(true);
              track(`open search modal`, {
                selectedPage: isLive ? "Live Casino Page" : "Casino Page",
                component: "searchModal - Search",
              });
            }}
            className="  w-10 min-w-10 h-10 rounded-full bg-primary/30 flex items-center justify-center"
          >
            <SVGIcon icon="search" className="w-4 h-4 text-tertiary-700" />
          </button>
        </div>
        <CasinoSearchModal
          isOpen={showSearchModal}
          onClose={() => {
            setShowSearchModal(false);
            track(`close search modal`, {
              selectedPage: isLive ? "Live Casino Page" : "Casino Page",
              component: "searchModal - Search",
            });
          }}
        />
      </div>
  );
};

export default Search;
